export const HEADER_Z_INDEX = 1000
export const DROPDOWN_Z_INDEX = HEADER_Z_INDEX - 1

export const INLINE_DIALOG_INDEX = HEADER_Z_INDEX + 10

export const POPOVER_INDEX = 100010
